import React from "react";
import { Row, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import { BsBoxArrowRight } from "react-icons/bs";
import "assets/css/Footer/footer.css";
import { useSelector, useDispatch } from "react-redux";
import { switchBackToOriginalAccount } from "../../Redux/Auth/actions";
import { useNavigate } from "react-router-dom";

function Footer(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.authReducer?.data);
  const switchedUser = useSelector((state) => state.authReducer?.isSwitched);

  const handleClickBackToAdmin = async () => {
    const res=await switchBackToOriginalAccount(dispatch);
    if (res?.response==="success"){
      navigate('/')
    }
  };
  const handleClick = () => {
    navigate("/account");
  };
  return (
    <footer>
      {/* <Container fluid={props.fluid ? true : false}> */}
      {!switchedUser && user?.role === "admin" ? (
        <>
          <Row className="d-flex justify-content-end mr-1">
            <Button
              className="d-flex justify-content-center align-items-center rounded-pill shadow custom-button"
              onClick={handleClick}
              style={{ cursor: "pointer",background:"transparent" ,color:'black'}}
            >
              Live Support Rep
              <a className="custom-exit-icon ml-3">
                <BsBoxArrowRight size={20} color="white" />
              </a>
            </Button>
          </Row>
        </>
      ) : (
        ""
      )}
      {switchedUser ? (
        <>
          <Row className="d-flex justify-content-end mr-1">
            <Button
              className="d-flex justify-content-between align-items-center rounded-pill shadow custom-button"
              onClick={handleClickBackToAdmin}
              style={{ cursor: "pointer",background:"transparent" ,color:'black' }}
            >
             Exit Account
              <a className="custom-exit-icon ml-3">
                <BsBoxArrowRight size={20} color="white" />
              </a>
            </Button>
          </Row>
        </>
      ) : (
        ""
      )}
      {/* </Container> */}
    </footer>
  );
}

Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool,
};

export default Footer;
